<app-index-navbar></app-index-navbar>

<main>
  <div class="relative pt-16 pb-20 flex content-center items-center justify-center min-h-screen-75">
    <div class="container relative mx-auto">
      <div class="items-center flex flex-wrap">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</main>

<app-footer></app-footer>